import * as tslib_1 from "tslib";
import { OnDestroy, OnInit, } from '@angular/core';
import { FormBuilder, } from '@angular/forms';
import { AppStateFacade, Setting, } from '@app-state';
import { UiModalComponent } from '@components/ui-modal/ui-modal.component';
import { QueueItemPriority, } from '@models';
import { TranslateService } from '@ngx-translate/core';
import { FileDownloadService, QueueItemService, } from '@services';
import { readFileContent } from '@utils/file.utils';
import UiValidators, { UI_QUEUE_ITEM_REFERENCE_MAX_LENGTH } from '@validators';
import * as moment from 'moment';
import { BehaviorSubject, Subject, } from 'rxjs';
import { finalize } from 'rxjs/operators';
export var TransactionFormControl;
(function (TransactionFormControl) {
    TransactionFormControl["reference"] = "reference";
    TransactionFormControl["priority"] = "priority";
    TransactionFormControl["dueDate"] = "dueDate";
    TransactionFormControl["deferDate"] = "deferDate";
    TransactionFormControl["specificContent"] = "specificContent";
    TransactionFormControl["keepProgress"] = "keepProgress";
})(TransactionFormControl || (TransactionFormControl = {}));
var TransactionUpsertModalComponent = /** @class */ (function (_super) {
    tslib_1.__extends(TransactionUpsertModalComponent, _super);
    function TransactionUpsertModalComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.TransactionFormControl = TransactionFormControl;
        _this.submitting$ = new BehaviorSubject(false);
        _this.isFileUploading$ = new BehaviorSubject(false);
        _this._formBuilder = _this._injector.get(FormBuilder);
        _this._queueService = _this._injector.get(QueueItemService);
        _this._downloadService = _this._injector.get(FileDownloadService);
        _this._translate = _this._injector.get(TranslateService);
        _this._appState = _this._injector.get(AppStateFacade);
        _this._destroyed$ = new Subject();
        _this._timezone = _this._appState.settings.get(Setting.timezone);
        return _this;
    }
    Object.defineProperty(TransactionUpsertModalComponent.prototype, "priorityTypes", {
        get: function () {
            var _this = this;
            return [QueueItemPriority.high, QueueItemPriority.normal, QueueItemPriority.low]
                .map(function (priority) { return ({
                id: priority,
                text: _this._translate.instant("PriorityType_" + priority),
            }); });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TransactionUpsertModalComponent.prototype, "selectedType", {
        get: function () {
            var _this = this;
            return this.priorityTypes.filter(function (priorityType) { return priorityType.id === _this.context.data.priority; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TransactionUpsertModalComponent.prototype, "slaDefaultPriority", {
        get: function () {
            return this.priorityTypes.filter(function (priorityType) { return priorityType.id === QueueItemPriority.high; });
        },
        enumerable: true,
        configurable: true
    });
    TransactionUpsertModalComponent.prototype.ngOnInit = function () {
        this.transactionForm = this._formBuilder.group(this._transactionFormConfig);
        if (this.isClone) {
            this.transactionForm.markAsDirty();
        }
    };
    TransactionUpsertModalComponent.prototype.ngOnDestroy = function () {
        this._destroyed$.next();
        this._destroyed$.complete();
    };
    TransactionUpsertModalComponent.prototype.onSubmit = function () {
        var _this = this;
        this.submitting$.next(true);
        this._submit$.pipe(finalize(function () {
            _this.submitting$.next(false);
        })).subscribe(function () {
            _this._snack.success(_this._translate.instant('save_successful'));
            _this._dialogRef.close({
                type: _this.context.isDuplicate ? 1 /* Add */ : 2 /* Update */,
            });
        }, function (error) {
            if (error.status === 403) {
                _this._snack.error(_this._translate.instant("snack_ou_access_denied"));
                _this._dialogRef.close({
                    type: 5 /* Failed */,
                });
            }
        });
    };
    Object.defineProperty(TransactionUpsertModalComponent.prototype, "downloadLink", {
        get: function () {
            return "/transaction-item-" + this.context.data.id + ".json";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TransactionUpsertModalComponent.prototype, "isClone", {
        get: function () {
            return this.context.isDuplicate;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TransactionUpsertModalComponent.prototype, "isSlaEnabled", {
        get: function () {
            return this.context.data.slaEnabled;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TransactionUpsertModalComponent.prototype, "isSubmitDisabled", {
        get: function () {
            return this.submitting$.value ||
                this.isFileUploading$.value ||
                !this.transactionForm ||
                // for !dirty, we want to disable if it was an edit
                (!this.transactionForm.dirty && !this.context.isDuplicate) ||
                !this.transactionForm.valid;
        },
        enumerable: true,
        configurable: true
    });
    TransactionUpsertModalComponent.prototype.downloadItemData = function (event) {
        event.preventDefault();
        this._downloadService.downloadStringAsFile("transaction-item-" + this.context.data.id + ".json", 'application/json', JSON.stringify(this.transactionForm.get(TransactionFormControl.specificContent).value));
    };
    TransactionUpsertModalComponent.prototype.specificDataChanged = function (files) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var resultAsString, result, e_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.isFileUploading$.next(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, readFileContent(files[0])];
                    case 2:
                        resultAsString = _a.sent();
                        result = JSON.parse(resultAsString);
                        this.transactionForm.get(TransactionFormControl.specificContent).setValue(result);
                        this.transactionForm.get(TransactionFormControl.specificContent).markAsDirty();
                        return [3 /*break*/, 5];
                    case 3:
                        e_1 = _a.sent();
                        this._snack.error(this._translate.instant("transaction_upsert_invalid_json"));
                        return [2 /*return*/];
                    case 4:
                        this.isFileUploading$.next(false);
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(TransactionUpsertModalComponent.prototype, "_submit$", {
        get: function () {
            if (!this.transactionForm) {
                throw new Error('Form is undefined');
            }
            this.submitting$.next(true);
            var progress = this.context.data.progress;
            if (this.context.isDuplicate ||
                this.transactionForm.get(TransactionFormControl.keepProgress).value === false) {
                progress = undefined;
            }
            var utcOffset = this._timezone ? moment.tz(this._timezone).utcOffset() : 0;
            var formValues = this.transactionForm.value;
            delete formValues['keepProgress'];
            var dueDateControl = this.transactionForm.get('dueDate');
            var deferDateControl = this.transactionForm.get('deferDate');
            var payload = tslib_1.__assign({}, formValues, { name: this.context.data.name, priority: this.transactionForm.get(TransactionFormControl.priority).value[0].id, 
                // adjust timezone manually before it is converted to UTC
                dueDate: dueDateControl.value && !this.context.data.dueDate ?
                    moment(dueDateControl.value).subtract(utcOffset, 'minutes') : dueDateControl.value, deferDate: deferDateControl.value && !this.context.data.deferDate ?
                    moment(deferDateControl.value).subtract(utcOffset, 'minutes') : deferDateControl.value, progress: progress });
            if (this.isClone) {
                return this._queueService.addQueueItem(payload);
            }
            return this._queueService.updateQueueItem(this.context.data.id, payload);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TransactionUpsertModalComponent.prototype, "_transactionFormConfig", {
        get: function () {
            var _a;
            return _a = {},
                _a[TransactionFormControl.reference] = [
                    this.context.data.reference,
                    UiValidators.maxLength(UI_QUEUE_ITEM_REFERENCE_MAX_LENGTH),
                ],
                _a[TransactionFormControl.priority] = [
                    this.isSlaEnabled ? this.slaDefaultPriority : this.selectedType,
                    UiValidators.required(),
                ],
                _a[TransactionFormControl.dueDate] = [
                    this.context.data.dueDate && this._timezone ?
                        this.context.data.dueDate.tz(this._timezone) : this.context.data.dueDate,
                ],
                _a[TransactionFormControl.deferDate] = [
                    this.context.data.deferDate && this._timezone ?
                        this.context.data.deferDate.tz(this._timezone) : this.context.data.deferDate,
                ],
                _a[TransactionFormControl.specificContent] = [
                    this.context.data.specificContent,
                ],
                _a[TransactionFormControl.keepProgress] = [
                    true,
                ],
                _a;
        },
        enumerable: true,
        configurable: true
    });
    return TransactionUpsertModalComponent;
}(UiModalComponent));
export { TransactionUpsertModalComponent };
